import { Box, Circle, IColorTypes } from '@bridebook/ui';
import hoverHoc from '@bridebook/web/components/common/hover-hoc';

type BoxProps = Parameters<typeof Box>[0];

interface IProps {
  icon: Function;
  iconWidth: number;
  color: keyof IColorTypes;
  onMouseEnter?: BoxProps['onMouseEnter'];
  onMouseLeave?: BoxProps['onMouseLeave'];
  hover?: boolean;
}

const Network = ({ icon, iconWidth, color, onMouseEnter, onMouseLeave, hover }: IProps) => {
  const Icon = icon;

  return (
    <Box {...{ onMouseEnter, onMouseLeave }}>
      <Circle size={30} borderWidth={2} borderColor={color} color={hover ? 'white' : color}>
        <Icon width={iconWidth} color={hover ? color : 'white'} />
      </Circle>
    </Box>
  );
};

export default hoverHoc(Network) as React.ComponentType<IProps>;
